import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./leftmenu.css";
import { Link, NavLink } from "react-router-dom";

const Leftmenu = ({ logout, user }) => {

    return (
        <>
            <div className="leftmenu">
                <div className="leftmenu-flex">
                    <div className="leftmenu-flex-box1">
                        <div className="leftmenu-logo">
                            <img src="/logoleftmenu.png" alt="" />
                        </div>
                    </div>
                    <div className="leftmenu-flex-box2" title={`${user?.role} + ${(user?.subroles || []).join(", ")}`}>
                        <div className="leftmenu-logo-user">
                            {(user?.fullname || "").trim().slice(0, 2).toUpperCase()}
                        </div>
                        <div className="leftmenu-fullname-user">
                            {user?.fullname}
                        </div>
                    </div>
                    <div className="leftmenu-flex-box3">
                        <NavLink className="link leftmenubtn" to={"/home"} >
                            <span>
                                <i class="fa-solid fa-chart-simple"></i>
                            </span>
                            <h4>
                                Аналитика
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/finance"} >
                            <span>
                                <i class="fa-solid fa-sack-dollar"></i>
                            </span>
                            <h4>
                                Финансы
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/arrivals"} >
                            <span>
                                <i class="fa-solid fa-plane-arrival"></i>
                            </span>
                            <h4>
                                Заезды
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/expend"} >
                            <span>
                                <i class="fa-solid fa-money-bill-transfer"></i>
                            </span>
                            <h4>
                                Расходы
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/operations"} >
                            <span>
                                <i class="fa-solid fa-receipt"></i>
                            </span>
                            <h4>
                                Операции
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/reports"} >
                            <span>
                                <i class="fa-solid fa-coins"></i>
                            </span>
                            <h4>
                                Отчеты
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/products"} >
                            <span>
                                <i class="fa-solid fa-barcode"></i>
                            </span>
                            <h4>
                                Товары
                            </h4>
                        </NavLink>
                        <NavLink className="link leftmenubtn" to={"/transports"} >
                            <span>
                                <i class="fa-solid fa-car-tunnel"></i>
                            </span>
                            <h4>
                                Автопарк
                            </h4>
                        </NavLink>
                    </div>
                </div>

                <div className="leftmenu-logout">
                    <button onClick={logout} title="Выйти">
                        <i className="fas fa-sign-out-alt"></i>
                        <span>Выйти</span>
                    </button>
                </div>
            </div>


        </>
    );
};
export default Leftmenu;
